import { render, staticRenderFns } from "./tender-records.vue?vue&type=template&id=7ba0cd1c&scoped=true"
import script from "./tender-records.vue?vue&type=script&lang=js"
export * from "./tender-records.vue?vue&type=script&lang=js"
import style0 from "./tender-records.vue?vue&type=style&index=0&id=7ba0cd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0cd1c",
  null
  
)

export default component.exports